<template>
    <div class="row">
        <div class="col-12 col-md-2">
            <div class="ob1-skeleton">
                <div class="ob1-skeleton-white" style="height: 70px" />
            </div>
        </div>
        <div class="col-12 col-md-10">
            <div class="ob1-skeleton">
                <div class="ob1-skeleton-white" style="height: 70px" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeviceDetailsReviewSkeleton",
}
</script>




